import { render, staticRenderFns } from "./contentprovidersform.vue?vue&type=template&id=0efa27f3&"
import script from "./contentprovidersform.vue?vue&type=script&lang=ts&"
export * from "./contentprovidersform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports